import script from "./ElencoDico.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoDico.vue?vue&type=script&setup=true&lang=js"

import "./ElencoDico.vue?vue&type=style&index=0&id=578c09ab&lang=css"

const __exports__ = script;

export default __exports__